import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import SwiperCore, { Navigation, Mousewheel } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { MdArrowBack, MdArrowForward } from "react-icons/md";

import { SubfamilyModel } from "../../models/SubfamilyModel";

import { breakpoints } from "../../data/SwiperData";

import VariantItem from "../VariantItem/VariantItem";

import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import "./Variant.css";

SwiperCore.use([Navigation, Mousewheel]);

interface Props {
  subfamilies: SubfamilyModel[];
}

const Variant = (props: Props) => {
  const slidesPerView = 4;

  return (
    <article className="variant mt-9">
      <Container className="variant-wrapper">
        <Tab.Container defaultActiveKey={`${props.subfamilies[0].name}`}>
          <Row className="variant-wrapper-tabs justify-content-center">
            <Col
              xs={4}
              sm={4}
              md="auto"
              lg="auto"
              xl="auto"
              className="align-self-center"
            >
              <div className="variant-wrapper-tabs-button-prev">
                <MdArrowBack className="variant-wrapper-tabs-button-prev-icon" />
              </div>
            </Col>
            <Col
              xs={4}
              sm={4}
              md={10}
              lg={10}
              xl={10}
              className="variant-wrapper-tabs-col"
            >
              <Swiper
                mousewheel={
                  props.subfamilies.length > slidesPerView ? true : false
                }
                navigation={{
                  prevEl: ".variant-wrapper-tabs-button-prev",
                  nextEl: ".variant-wrapper-tabs-button-next",
                }}
                centerInsufficientSlides
                breakpoints={breakpoints(slidesPerView)}
              >
                {props.subfamilies.map((item, index) => {
                  return (
                    <SwiperSlide key={index}>
                      <Nav variant="pills" className="justify-content-center">
                        <Nav.Item>
                          <Nav.Link eventKey={item.name}>{item.name}</Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </Col>
            <Col
              xs={4}
              sm={4}
              md="auto"
              lg="auto"
              xl="auto"
              className="align-self-center text-right"
            >
              <div className="variant-wrapper-tabs-button-next">
                <MdArrowForward className="variant-wrapper-tabs-button-next-icon" />
              </div>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <Tab.Content>
                {props.subfamilies.map((item, index) => {
                  return <VariantItem subfamily={item} key={index} />;
                })}
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </Container>
    </article>
  );
};

export default Variant;
